namespace AgerLMS.Logging {
    export interface PaymentResponseLogRow {
        Id?: number;
        PaymentId?: number;
        ConversationId?: string;
        MethodName?: string;
        ServiceName?: string;
        PaymentLogType?: PaymentLogTypes;
        Status?: string;
        RequestJson?: string;
        ResponseJson?: string;
        IpNumber?: string;
        PaidPrice?: number;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace PaymentResponseLogRow {
        export const idProperty = 'Id';
        export const nameProperty = 'MethodName';
        export const localTextPrefix = 'Logging.PaymentResponseLog';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'Logging:PaymentResponseLog:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            PaymentId = "PaymentId",
            ConversationId = "ConversationId",
            MethodName = "MethodName",
            ServiceName = "ServiceName",
            PaymentLogType = "PaymentLogType",
            Status = "Status",
            RequestJson = "RequestJson",
            ResponseJson = "ResponseJson",
            IpNumber = "IpNumber",
            PaidPrice = "PaidPrice",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
